import type { IconAliases } from "vuetify";
import {
  ArrowDown,
  ArrowUp,
  ArrowLeft,
  ArrowRight,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Check,
  X,
  Trash2,
  Info,
  AlertTriangle,
  AlertCircle,
  Circle,
  Menu,
  ChevronRight as SubgroupIcon,
  ChevronDown as DropdownIcon,
  Dot,
  Pen,
  Star,
  StarHalf,
  Loader,
  File,
  Plus,
  Minus,
  Calendar,
  Pipette,
  Upload,
  Palette,
  Command,
  CornerDownLeft,
  Keyboard,
  Delete,
  Clock,
} from "@lucide/vue";

import SolidCircle from "@/assets/icons/SolidCircle";
import CheckboxMarked from "@/assets/icons/CheckboxMarked";
import CheckboxBlank from "@/assets/icons/CheckboxBlank";
import CheckboxMinus from "@/assets/icons/CheckboxMinus";

export const icons: IconAliases = {
  collapse: ChevronUp,
  complete: Check,
  cancel: X,
  close: X,
  delete: Trash2,
  clear: X,
  success: Check,
  info: Info,
  warning: AlertTriangle,
  error: AlertCircle,
  prev: ChevronLeft,
  next: ChevronRight,
  checkboxOn: CheckboxMarked,
  checkboxOff: CheckboxBlank,
  checkboxIndeterminate: CheckboxMinus,
  delimiter: SolidCircle,
  sortAsc: ArrowUp,
  sortDesc: ArrowDown,
  expand: ChevronDown,
  menu: Menu,
  subgroup: SubgroupIcon,
  dropdown: DropdownIcon,
  radioOn: Dot,
  radioOff: Circle,
  edit: Pen,
  ratingEmpty: Star,
  ratingFull: Star,
  ratingHalf: StarHalf,
  loading: Loader,
  first: ChevronsLeft,
  last: ChevronsRight,
  unfold: ChevronDown,
  file: File,
  plus: Plus,
  minus: Minus,
  calendar: Calendar,
  treeviewCollapse: ChevronDown,
  treeviewExpand: ChevronRight,
  eyeDropper: Pipette,
  upload: Upload,
  color: Palette,
  command: Command,
  ctrl: Keyboard,
  space: Keyboard,
  shift: Keyboard,
  alt: Keyboard,
  enter: CornerDownLeft,
  arrowup: ArrowUp,
  arrowdown: ArrowDown,
  arrowleft: ArrowLeft,
  arrowright: ArrowRight,
  backspace: Delete,
  clock: Clock,
};
